var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgVip = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    stroke: "black",
    strokeOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.032 11.0792L16.0032 8.82463C15.8187 8.61832 15.5545 8.50048 15.2749 8.49969H11.1549C10.8752 8.50048 10.6062 8.61832 10.4132 8.82463L8.29204 11.0792C8.20563 11.1721 8.15673 11.2935 8.15508 11.4191L8.15201 11.5691C8.14939 11.6859 8.18776 11.799 8.26046 11.889L12.6493 17.3178C12.7421 17.4321 12.8819 17.4981 13.0306 17.4978C13.1793 17.4981 13.3218 17.4321 13.4193 17.3178L18.0305 11.889C18.1068 11.799 18.1498 11.6859 18.152 11.5691L18.1551 11.4191C18.1586 11.2935 18.1147 11.1721 18.032 11.0792ZM12.6568 15.7332L9.41363 11.734C9.34928 11.7078 9.31945 11.6339 9.34701 11.5691C9.37457 11.5042 9.44909 11.4728 9.51344 11.4991H11.2884C11.5141 11.488 11.7161 11.6294 11.7814 11.844L12.8991 15.6182C12.9295 15.6845 12.8999 15.7639 12.833 15.7957C12.766 15.8274 12.6871 15.7994 12.6568 15.7332ZM13.6884 11.4991H16.7734C16.8229 11.4984 16.8679 11.4687 16.8883 11.4233C16.9086 11.3779 16.9006 11.3253 16.8677 11.2891L15.3473 9.59946C15.3242 9.5734 15.2909 9.55854 15.2557 9.55854C15.2205 9.55854 15.1866 9.5734 15.1623 9.59946L13.5977 11.2891C13.5627 11.326 13.5529 11.3798 13.5727 11.4256C13.5925 11.4715 13.6381 11.5004 13.6884 11.4991Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/VIP.25bb6e91.svg";
export { ForwardRef as ReactComponent };